<template>
  <div class="notice">
    <div class="container">
      <div>
        <Title />
        <div class="row justify-content-between">
          <Breadcrumb />
          <div class="col-12 col-sm text-end mb-3 mb-sm-0">
            <button
              type="button"
              class="btn btn-transparent me-3"
              @click="getData"
            >
              取消
            </button>
            <button type="button" @click="save" class="btn btn-light">
              儲存
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="card mb-3">
            <div class="card-body">
              <h5 class="card-title mb-3">購買注意事項</h5>
              <quill v-model="form.notice" />
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="card mb-3">
            <div class="card-body">
              <h5 class="card-title mb-3">匯款資訊</h5>
              <quill v-model="form.pay_notice" />
            </div>
          </div>
        </div>
      </div>
      <div class="text-end mb-3">
        <button type="button" class="btn btn-secondary me-3" @click="getData">
          取消
        </button>
        <button type="button" @click="save" class="btn btn-gradient">
          儲存
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { onePage } from '@/http/api/onePage.js'
import { mapState, mapMutations, mapGetters } from 'vuex'
import quill from '@/components/plugin/Quill.vue'
import Title from '@/components/layout/Title.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'

export default {
  name: 'Notice',
  components: { quill, Title, Breadcrumb },
  data () {
    return {
      errMsg: null,
      errMsgKey: {
        notice: '購買注意事項',
        pay_notice: '匯款資訊'
      },
      form: {
        notice: null,
        pay_notice: null
      }
    }
  },
  computed: {
    ...mapState(['token']),
    ...mapGetters(['errMsgInfo'])
  },
  watch: {
    'token.headers.Authorization': function (data) {
      if (data) {
        this.getData()
      }
    }
  },
  methods: {
    ...mapMutations([
      'Loading',
      'Loaded',
      'AlertsInfo',
      'Alerted',
      'SetRouterName',
      'SetErrMsg',
      'SetErrMsgKey'
    ]),
    getData () {
      const vm = this
      vm.Loading()
      onePage
        .getNotice(vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.form = data.data
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    save () {
      const vm = this
      vm.Loading()
      onePage
        .updateNotice(vm.form, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '更新資料成功'
            })
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    }
  },
  created () {
    const vm = this
    vm.SetRouterName(vm.$route.name)
  },
  mounted () {
    const vm = this
    if (vm.token.headers.Authorization) {
      vm.getData()
    }
  }
}
</script>
